import { Component } from '@angular/core';

@Component({
    selector: 'pd-reload',
    template: ''
})
export class ReloadComponent {
    // An empty component used to clear and force a component reload between browser history selections
}
